import * as React from "react"

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12.25} height={15} {...props}>
    <defs>
      <style>{".cls-1{fill:#00446e}"}</style>
    </defs>
    <g id="Group_781" data-name="Group 781" transform="translate(17279 -10835)">
      <g id="noun-bin-3370489" transform="translate(-17279 10835)">
        <path
          id="Path_302"
          data-name="Path 302"
          className="cls-1"
          d="M147.371 19h-3.125v-1a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1h-3.126a.5.5 0 0 0-.5.5V21a.5.5 0 0 0 .5.5h.125v9.69a1.315 1.315 0 0 0 1.315 1.31h8.375a1.315 1.315 0 0 0 1.31-1.31V21.5h.125a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 0-.5-.5zm-7.125-.5h3v.5h-3zM136.62 20h10.25v.5h-10.25zm9.625 11.19a.31.31 0 0 1-.31.31h-8.375a.315.315 0 0 1-.315-.31V21.5h9z"
          transform="translate(-135.62 -17.5)"
        />
        <path
          id="Path_303"
          data-name="Path 303"
          className="cls-1"
          d="M333 200.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 1 0-1 0v7a.5.5 0 0 0 .5.5z"
          transform="translate(-326.875 -187.5)"
        />
        <path
          id="Path_304"
          data-name="Path 304"
          className="cls-1"
          d="M420.5 200.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 1 0-1 0v7a.5.5 0 0 0 .5.5z"
          transform="translate(-411.875 -187.5)"
        />
        <path
          id="Path_305"
          data-name="Path 305"
          className="cls-1"
          d="M245.5 200.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 1 0-1 0v7a.5.5 0 0 0 .5.5z"
          transform="translate(-241.875 -187.5)"
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent
